import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { useSuggestionSearchBarContext } from '@aibees/elephant/feature/suggestion-search-bar/context';
import { Icon } from '@aibees/shared/components';
import { Box, Typography } from '@mui/material';
import * as Styled from './styles';
import * as SX from './sx';
import type { LimitMessageProps as Props } from './types';

export const LimitMessage = memo(({ className }: Props) => {
  const { limitReached, limitErrorMsg } = useSuggestionSearchBarContext();

  if (!limitReached || !limitErrorMsg) return null;

  return (
    <Box px={1} pt={1} sx={SX.content}>
      <Styled.Wrapper
        className={classnames('LimitMessage', className)}
        sx={SX.root}
      >
        <Icon name="info-fill" sxx={SX.icon} size={16} />
        <Typography sx={SX.text}>{limitErrorMsg}</Typography>
      </Styled.Wrapper>
    </Box>
  );
});

LimitMessage.displayName = 'LimitMessage';
